import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

type Props = {
  children: string | string[];
};

export const ErrorText = ({children}: Props) => {
  return (
    <Tailwind>
      <p className="mt-8 text-base text-red-500">{children}</p>
    </Tailwind>
  );
};
